<!-- <ion-content> -->
<div class="one3d-keyFeatures-mobile">
  <div class="one3d-keyFeatures-upper">
    <div class="one3d-keyFeatures-close">
      <ion-icon (click)="close()" name="close" large></ion-icon>
    </div>
    <div class="one3d-keyFeatures-content">
      <div class="one3d-keyFeatures-selected">
        <h4 class="one3d-keyFeatures-model-title">
          {{ variantInfo?.variant_name | uppercase }}
        </h4>
        <div class="one3d-keyFeatures-details">
          <span class="one3d-keyFeatures-details-price">
            {{
              variantInfo.variant_id == selectedVariant.variant_id
                ? globalService.currencyFormatter(
                    globalService.selectedConfigPrice?.drive_away_price
                  )
                : globalService.currencyFormatter(
                    variantInfo.color[0].total_price
                  )
            }}
          </span>
          <span class="one3d-keyFeatures-details-ex-show"
            >{{ "KEY_FEATURE.DRIVE_AWAY_PRICE" | translate }} *</span
          >

          <button
            *ngIf="variantInfo.variant_id == selectedVariant.variant_id"
            class="one3d-keyFeatures-details-btn"
            translate
          >
            KEY_FEATURE.SELECTED_VARIANT
          </button>
        </div>
      </div>
      <div class="one3d-keyFeatures-list">
        <!-- <h5 class="one3d-keyFeatures-list-title">{{'KEY_FEATURE.KEY_FEATURES' | translate}} -</h5> -->
        <ul
          class="one3d-scrollable-wrapper-custom one3d-keyFeatures-list-ul"
          [ngClass]="{ 'one3d-full-height-features': variants?.length == 1 }"
        >
          <!-- <li *ngFor="let feature of variantInfo.features">
            {{ feature.feature_name }}
          </li>  -->
          <!--new disclaimer-->
          <!-- <h6 *ngIf="variantInfo.packages && variantInfo.packages.length > 0">
            This pack includes:
            <br>
            <br>
            <ul *ngFor="let package of variantInfo.packages">
              <li *ngFor="let accessory of package.accessoriesList">
                {{ accessory.marketing_name }}
              </li>
            </ul>
          </h6> -->
          <div class="one3d-key-features-info">
            <p>
              {{ variantInfo.variant_desc }}
            </p>
          </div>
          <!--new disclaimer-->
        </ul>
      </div>
    </div>
  </div>

  <div *ngIf="variants.length > 1" class="one3d-keyFeatures-controls">
    <ion-row class="one3d-ef-bottom ion-justify-content-between">
      <!-- <ion-col size="2" class="ion-no-padding"> -->
      <ion-button
        (click)="prev()"
        [disabled]="currentIndex == 0"
        class="one3d-ef-arrow-btn"
        size="small"
      >
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
      <!-- </ion-col> -->
      <ion-col
        class="ion-justify-content-center ion-align-items-center one-3d-flex"
        size="6"
      >
        <span
          *ngFor="let variant of variants"
          class="one3d-dot"
          [ngClass]="{
            'one3d-active': variant.variant_id == variantInfo.variant_id
          }"
        ></span>
      </ion-col>
      <!-- <ion-col size="2" class="ion-no-padding"> -->
      <ion-button
        [disabled]="currentIndex == variants.length - 1"
        class="one3d-ef-arrow-btn"
        size="small"
        (click)="next()"
      >
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
      <!-- </ion-col> -->
    </ion-row>
  </div>
</div>
<!-- </ion-content> -->
